import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../../../api";
import AnimatedProgressBar from "../../../components/AnimatedProgressbar/AnimatedProgressBar";

const UserWiseDetails = ({ uid }) => {
  const location = useLocation();
  const { userid, depart,selectedYear, teacher_name } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);


  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/api/reports/getteachercouser/${userid}`, {
          params: { selectedYear },
        });
        setData(res.data);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [uid, selectedYear]);
console.log(data)
  // Group data by semester and course
  const groupedData = data.reduce((acc, item) => {
    const semesterKey = `Semester ${item.semester}`;
    if (!acc[semesterKey]) acc[semesterKey] = {};

    const courseKey = `${item.coursecode} - ${item.course_name}`;
    if (!acc[semesterKey][courseKey]) acc[semesterKey][courseKey] = [];

    // Add usercourse_id for each item in the grouped data
    acc[semesterKey][courseKey].push({
      ...item,
      usercourse_id: item.usercourse_id,
    });

    return acc;
  }, {});
  console.log(groupedData)
  return (
    <div className="w-full mt-8">
      <h1 className="text-2xl font-bold text-center text-purple-800">
        User Details - {teacher_name}
      </h1>
      <p className="text-center text-gray-700 mt-2">
        Academic Year: {selectedYear}
      </p>

      {loading ? (
        <p className="text-blue-500 text-center mt-4">Loading...</p>
      ) : Object.keys(groupedData).length > 0 ? (
        Object.keys(groupedData).map((semester, semIndex) => (
          <div key={semIndex} className="mt-8">
            <h2 className="text-2xl font-bold text-purple-700 mb-4">
              {semester}
            </h2>
            {Object.keys(groupedData[semester]).map((course, courseIndex) => (
              <div key={courseIndex} className="mt-6">
                <AnimatedProgressBar
                  usercourseid={groupedData[semester][course][0].usercourse_id}
                />
                <h3 className="text-xl font-semibold text-purple-600 mb-2">
                  {course}
                </h3>
                
                <div className="overflow-x-auto">
                  <table className="min-w-full border-collapse border border-gray-300">
                    <thead>
                      <tr className="bg-purple-800 text-white">
                        <th className="border border-gray-300 px-4 py-2">
                          Set/Target
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO1
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO2
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO3
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO4
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO5
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO6
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO7
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO8
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO9
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO10
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO11
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PO12
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PSO1
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          PSO2
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {groupedData[semester][course].map((item, idx) => (
                        <tr
                          key={idx}
                          className={
                            idx % 2 === 0 ? "bg-purple-200" : "bg-purple-100"
                          }
                        >
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.isset === 0
                              ? "Set"
                              : item.isset === 1
                              ? "Target"
                              : "Not Set"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_1 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_2 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_3 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_4 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_5 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_6 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_7 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_8 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_9 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_10 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_11 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.po_12 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.pso_1 || "-"}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.pso_2 || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))}
          </div>
        ))
      ) : (
        <p className="text-red-500 text-center mt-4">No data available.</p>
      )}
    </div>
  );
};

export default UserWiseDetails;
